import { useSelector } from 'react-redux'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'

import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Divider, Link } from '@mui/material'

import ToolTip from 'components/Common/ToolTip'
import BusinessAvatarHome from '../BusinessProfileCard/components/constants/BusinessAvatarHome'
import { CompanyLogo } from 'assets'

const ProfileCardContainer = styled(Box)(({ theme }) => ({
  minHeight: '100%',
  display: 'flex',
  alignItems: 'baseline',
  overflow: 'hidden',
}))

const BusinessSummary = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'baseline',
  justifyContent: 'space-between',
}))

const BusinessInformation = props => {
  const { businessData } = props

  const { business_info } = useSelector(state => state.apiResponseReducers.dashboardInfo)
  const navigate = useNavigate()

  const handleClick = () => {
    navigate('/correct-your-data')
  }

  // const { credit_risk_score_max } = businessData

  const company = business_info?.claimed_business_details?.company?.toLowerCase() || 'Markaaz'

  const verifiedTooltip = (
    <Box>
      <Typography variant="body2" color="white">
        This business has been successfully claimed and verified by Markaaz. To learn more, see “Verification” in
        Markaaz’s&nbsp;
        <Link
          sx={{ whiteSpace: 'nowrap', textDecorationColor: 'white !important' }}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          href="https://markaaz.com/terms-and-conditions/"
        >
          <Typography component="span" variant="body2B" color="white">
            Terms and Conditions
          </Typography>
        </Link>
        .
      </Typography>
    </Box>
  )

  return (
    <ProfileCardContainer>
      <BusinessSummary>
        <Box
          sx={{
            marginBottom: '15px',
            textAlign: 'left',
          }}
        >
          <Typography
            variant="h6"
            sx={{ cursor: 'pointer', textTransform: 'capitalize', whiteSpace: 'nowrap' }}
            onClick={handleClick}
            title={company}
          >
            {company}
          </Typography>
          <Typography variant="overline3" color={'#25245F'}>
            Verified by Markaaz<sup>TM</sup>&nbsp;
            <ToolTip content={verifiedTooltip} /> <br />
            {moment(business_info.claimed_business_details?.claimedAt).format('MM/DD/YYYY')}&nbsp;
          </Typography>
        </Box>
        <Divider
          variant="middle"
          sx={{
            align: 'center',
            border: '1px solid',
            Color: '#CEE4F5',
            width: '236px',
            margin: '5px',
          }}
        />

        <Box
          sx={{
            marginTop: '15px',
            textAlign: 'left',
          }}
        >
          {businessData?.details.photoFileId || businessData?.web ? (
            <Box
              sx={{
                height: '0px',
                width: '240px',
                marginBottom: '50px',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'center',
              }}
              onClick={handleClick}
            >
              <BusinessAvatarHome model={businessData} width={140} height={110} />
            </Box>
          ) : (
            <Box sx={{ cursor: 'pointer' }} onClick={handleClick}>
              {/* <img style={{ width: '238px' }} src={BusinessLogo} alt="businessdummylogo" /> */}
              <CompanyLogo />
            </Box>
          )}
        </Box>
      </BusinessSummary>
    </ProfileCardContainer>
  )
}

export default BusinessInformation
